import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/luxury-theme.css";
import App from "./App";
import "./utils/disableLogs"; // Désactive les logs console en production

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
